import React from 'react';
import {Link, Route, Switch, withRouter} from 'react-router-dom';
import {connect} from "react-redux";
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import profile from '../../images/img.jpg';
import FontAwesome from 'react-fontawesome';

import TopNavigation from "../../components/TopNavigation/index";
import SidebarMenu from "../../components/SidebarMenu/index";

import Admins from "../Admins";
import Awards from "../Awards";
import Avatars from "../Avatars";
import Badges from "../Badges";
import EducationMaterials from "../EducationMaterials";
import Help from "../Help";
import Main from "../Main"
import Newsfeeds from "../Newsfeeds";
import Notifications from "../Notifications";
import Profile from "../Profile";
import Questions from "../Questions";
import Settings from "../Settings";
import Statistics from "../Statistics";
import Specials from "../Specials";
import Users from "../Users";
import UserStories from '../UserStories';

import './style.css';
import TakenAwards from '../TakenAwards';

class Root extends React.Component {
    render() {
        let {sessionData, notifications} = this.props;
        let {loggedUser} = sessionData;

        const tooltipSettings = (
            <Tooltip id="tooltip-settings">Nastavení</Tooltip>
        );
        const tooltipFullScreen = (
            <Tooltip id="tooltip-full-screen">Zvětšit</Tooltip>
        );
        const tooltipLock = (
            <Tooltip id="tooltip-lock">Zamknout</Tooltip>
        );
        const tooltipLogout = (
            <Tooltip id="tooltip-logout">Odhlásit</Tooltip>
        );

        return (
            <div className="container body">
                <div className="main-container">
                    <div className="col-md-3 left-col">
                        <div className="left-col scroll-view">
                            <div className="navbar nav-title">
                                <Link to="/" className="site-title">
                                    <FontAwesome name="car" tag="i"/>
                                    <span style={{marginLeft: '5px'}}>Nebourám.cz</span>
                                </Link>
                            </div>
                            <div className="clearfix"/>
                            {/* menu profile quick info */}
                            <div className="profile clearfix">
                                <div className="profile-pic">
                                    <img src={profile} alt="..." className="img-circle profile-img"/>
                                </div>
                                <div className="profile-info">
                                    <span>Vítám tě,</span>
                                    <h2>{loggedUser ? (loggedUser.firstname && loggedUser.surname) ? loggedUser.firstname + " " + loggedUser.surname : loggedUser.nickname : "Neznámý uživatel"}</h2>
                                </div>
                            </div>
                            {/* menu profile quick info */}
                            <br />
                            {/* sidebar menu */}
                            <SidebarMenu pathname={this.props.location.pathname}/>
                            {/* /sidebar menu */}
                            {/* /menu footer buttons */}
                            <div className="sidebar-footer hidden-small">
                                <OverlayTrigger placement="top" overlay={tooltipSettings}>
                                    <Link to="/">
                                        <span className="glyphicon glyphicon-cog" aria-hidden="true"/>
                                    </Link>
                                </OverlayTrigger>
                                <OverlayTrigger placement="top" overlay={tooltipFullScreen}>
                                    <Link to="/">
                                        <span className="glyphicon glyphicon-fullscreen" aria-hidden="true"/>
                                    </Link>
                                </OverlayTrigger>
                                <OverlayTrigger placement="top" overlay={tooltipLock}>
                                    <Link to="/">
                                        <span className="glyphicon glyphicon-eye-close" aria-hidden="true"/>
                                    </Link>
                                </OverlayTrigger>
                                <OverlayTrigger placement="top" overlay={tooltipLogout}>
                                    <Link to="/Logout">
                                        <span className="glyphicon glyphicon-off" aria-hidden="true"/>
                                    </Link>
                                </OverlayTrigger>
                            </div>
                            {/* /menu footer buttons */}
                        </div>
                    </div>
                    {/* top navigation */}
                    <TopNavigation notifications={notifications} loggedUser={loggedUser} />
                    {/* /top navigation */}
                    {/* page content */}
                    <Switch>
                        <Route exact path='/' component={() => <Main {...this.props} />}/>
                        <Route path='/Admins' component={() => <Admins {...this.props} />}/>
                        <Route path='/Avatars' component={() => <Avatars {...this.props} />}/>
                        <Route path='/Awards' component={() => <Awards {...this.props} />}/>
                        <Route path='/TakenAwards' component={() => <TakenAwards {...this.props} />}/>
                        <Route path='/Badges' component={() => <Badges {...this.props} />}/>
                        <Route path='/EducationMaterials' component={() => <EducationMaterials {...this.props} />}/>
                        <Route path='/Help' component={() => <Help {...this.props} />}/>
                        <Route path='/Newsfeeds' component={() => <Newsfeeds {...this.props} />}/>
                        <Route path='/Notifications' component={() => <Notifications {...this.props} />} />
                        <Route path="/Profile" component={() => <Profile {...this.props} />}/>
                        <Route path='/Questions' component={() => <Questions {...this.props} />}/>
                        <Route path='/Settings' component={() => <Settings {...this.props} />}/>
                        <Route path='/Specials' component={() => <Specials {...this.props} />}/>
                        <Route path='/Statistics' component={() => <Statistics {...this.props} />}/>
                        <Route path='/UserStories' component={() => <UserStories {...this.props} />} />
                        <Route path='/Users' component={() => <Users {...this.props} />}/>
                    </Switch>
                    {/* /page content */}
                    {/* footer content */}
                    <div>
                        <div className="pull-right"/>
                        <div className="clearfix"/>
                    </div>
                    {/* /footer content */}
                </div>
            </div>
        );
    }
}

const mapStateToProps = function(state){
    return {
        notifications: state.notifications.notifications,
    }
};

export default withRouter(connect(mapStateToProps)(Root));



/** WEBPACK FOOTER **
 ** ./src/containers/Root/index.js
 **/